<template>
  <div
    class="settings-card shadow-sm"
    :data-name="name"
    :id="kebabCase(name)"
  >
    <h4 class="mb-4 text-xl font-weight-bold text-gray-500">{{ name }}</h4>
    <slot></slot>
  </div>
</template>

<script>
const kebabCase = require('lodash/kebabCase');

export default {
  name: 'UserProfileCard',
  props: ['name'],
  methods: {
    kebabCase(str) {
      return kebabCase(str);
    },
  },
};
</script>

<style scoped>
.settings-card {
  background: white;
  padding: 30px 0;
  margin-bottom: 20px;
  border-radius: 10px;
}
</style>
